import styled from 'styled-components'
import { devices } from '../../../utils/screen_sizes'
import { solidBlack } from '../../../utils/colors'

export const StyledSloganSection = styled.section`
    text-align: center;
`
export const SecondarySlogan = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: #fff;
    height: 40vh;

    h4 {
        color: ${solidBlack};
        padding: 48px;
    }

    @media ${devices.mobileS} {
        height: 20vh;
    }
    @media ${devices.mobileM} {
        height: 20vh;
    }
    @media ${devices.mobileL} {
        height: 15vh;
    }
    @media ${devices.laptop} {
        height: 20vh;
    }
    @media ${devices.desktop} {
        height: auto;
    }
`
export const PrimarySlogan = styled.div`
    background-color: #54beb6;
    background-image: url('/assets/images/sloganSection/Mid-Banner-v2-uzaChap.png');
    background-size: cover;
    background-repeat: no-repeat;
    color: #fff;
    padding: 48px 16px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 40vh;

    h1 {
        font-size: 2rem;
    }

    Button {
        margin-top: 16px;
        color: #fff;
        background: #444;
        width: 120px;
        border-radius: 32px;
    }

    @media ${devices.mobileM} {
    }
    @media ${devices.laptop} {
        font-size: 2.4rem;
        height: 30vh;
    }
    @media ${devices.desktop} {
        font-size: 2.4rem;
        height: 30vh;
    }
`
export const StyledStoresSection = styled.div`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 16px;
    width: 75vw;
    margin: 0 auto;

    text-align: left;
    .store-card {
        box-shadow: rgba(0, 0, 0, 0.06) 0px 3px 5px -1px,
            rgba(0, 0, 0, 0.043) 0px 6px 10px 0px,
            rgba(0, 0, 0, 0.035) 0px 1px 18px 0px;
        border-radius: 5px;
        padding: 20px;
        color: #000;
        background: #fff;
        h4 {
            font-weight: lighter;
            font-size: 1.2rem;
        }
        p {
            color: #707070;
            font-weight: normal;
        }
        .store-location {
            margin: 0 0 0.2rem 0;
            font-size: 0.875rem;
            color: #707070;
        }

        .store-card-footer {
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            align-items: center;

            p {
                margin: 0;
                font-size: 0.875rem;
            }
            .open-store {
                display: flex;
                margin-top: 0.875rem;
            }
            button {
                background: transparent;
                outline: none;
                border: none;
                color: #42c8b7;
                font-weight: bold;
                font-size: 0.875rem;
                cursor: pointer;
            }
        }
    }

    @media ${devices.mobileS} {
        grid-template-columns: repeat(1, 1fr);
        width: 80vw;
        margin: 0 auto;
    }
    @media ${devices.mobileM} {
        grid-template-columns: repeat(1, 1fr);
        width: 80vw;
        margin: 0 auto;
    }
    @media ${devices.mobileL} {
        grid-template-columns: repeat(2, 1fr);
        width: 80vw;
        margin: 0 auto;
    }
    @media ${devices.laptopL} {
        grid-template-columns: repeat(2, 1fr);
        width: 75vw;

        .store-card {
            box-shadow: rgba(0, 0, 0, 0.06) 0px 3px 5px -1px,
                rgba(0, 0, 0, 0.043) 0px 6px 10px 0px,
                rgba(0, 0, 0, 0.035) 0px 1px 18px 0px;
            border-radius: 5px;
            padding: 20px;
            color: #000;
            background: #fff;
            h4 {
                font-weight: lighter;
                font-size: 1.2rem;
            }
            p {
                color: #707070;
                font-weight: normal;
            }
        }
        .store-location {
            margin: 0 0 0.2rem 0;
            font-size: 0.875rem;
            color: #707070;
        }

        .store-card-footer {
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            align-items: center;

            p {
                margin: 0;
                font-size: 0.875rem;
            }
            .open-store {
                display: flex;
                margin-top: 0.875rem;
            }

            button {
                background: transparent;
                outline: none;
                border: none;
                color: #42c8b7;
                font-weight: bold;
                font-size: 0.875rem;
                cursor: pointer;
            }
        }
    }
`
// partners page
export const PartnerSecondarySlogan = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: #fff;
    height: 40vh;

    h4 {
        color: ${solidBlack};
        padding: 48px;
    }

    @media ${devices.mobileS} {
        height: 15vh;
    }
    @media ${devices.mobileM} {
        height: 15vh;
    }
    @media ${devices.mobileL} {
        height: 12vh;
    }
    @media ${devices.laptop} {
        height: 20vh;
    }

    @media ${devices.desktop} {
        height: 20vh;
    }
`
